import Crud from './Crud.vue';
import NavigationBar from './NavigationBar.vue';
// import FormDateRange from './FormDateRange.vue';

const components = {
  Crud,
  NavigationBar,
  // FormDateRange,
};
const prefix = 'Cfmoto';
const install = function install(Vue) {
  if (install.installed) return;
  Object.keys(components).forEach((key) => {
    const componentName = prefix + key;
    Vue.component(componentName, components[key]);
  });
};

// auto install
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}
export default {
  version: process.env.VERSION, // eslint-disable-line no-undef

  install,
  ...components,
};
